import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ONLINE_PAYMENT_TERMINAL } from '@yme/common/endpoints';
import { setIsPaymentNotAllowed, setIsTerminalPaymentIsProcessing, setIsWentWrong, setPaymentErrorCondition, setTerminalResult, } from './actions';
import { DevicePaymentConditions, ErrorPaymentConditions, MAX_RETRIES, PAY_ONLINE_BY_TERMINAL, WrongPaymentConditions, } from './constants';
function requireParams(...params) {
    return params.every((param) => !!param);
}
const payByTerminal = (params) => {
    return axios.post(ONLINE_PAYMENT_TERMINAL, {
        ...params,
    });
};
function dispatchProcessResult(result, dispatch) {
    if (result.errorCondition) {
        if (result.errorCondition === ErrorPaymentConditions.NotAllowed) {
            dispatch(setIsPaymentNotAllowed(true));
        }
        if (WrongPaymentConditions.includes(result.errorCondition)) {
            dispatch(setIsWentWrong(true));
        }
        dispatch(setPaymentErrorCondition(result.errorCondition));
    }
    dispatch(setTerminalResult(result));
}
export const payOnlineByTerminal = createAsyncThunk(PAY_ONLINE_BY_TERMINAL, async ({ orderNumber, cartId, projectKey, locale, terminalPOIID, saleID }, { dispatch, rejectWithValue }) => {
    if (!requireParams(orderNumber, cartId, projectKey, locale)) {
        return rejectWithValue('Missing required parameters');
    }
    dispatch(setIsTerminalPaymentIsProcessing(true));
    let attempts = 0;
    while (attempts <= MAX_RETRIES) {
        try {
            const response = await payByTerminal({
                cartId,
                orderNumber,
                projectKey,
                locale,
                terminalPOIID,
                saleID,
            });
            const result = response.data;
            if (DevicePaymentConditions.includes(result.errorCondition) &&
                attempts < MAX_RETRIES) {
                console.error(`Attempt ${attempts + 1}: Received '${result.errorCondition}', retrying...`);
                attempts++;
                continue;
            }
            else if (DevicePaymentConditions.includes(result.errorCondition) &&
                attempts >= MAX_RETRIES) {
                dispatch(setIsPaymentNotAllowed(true));
                dispatch(setTerminalResult(result));
                break;
            }
            dispatchProcessResult(result, dispatch);
            break;
        }
        catch (error) {
            if (attempts >= MAX_RETRIES) {
                console.error(`Error after ${attempts + 1} attempts: `, error);
                dispatch(setIsPaymentNotAllowed(true));
                dispatch(setIsTerminalPaymentIsProcessing(false));
                return rejectWithValue(error?.response?.data);
            }
            console.warn(`Attempt ${attempts + 1} failed, retrying...`);
            attempts++;
        }
    }
    dispatch(setIsTerminalPaymentIsProcessing(false));
});
